require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./information-security-and-quality-assurance-information-security-and-quality-assurance-projects-issue-tracker.json") })
        }
      }, "path---information-security-and-quality-assurance-information-security-and-quality-assurance-projects-issue-tracker");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---information-security-and-quality-assurance-information-security-and-quality-assurance-projects-issue-tracker!./.cache/json/information-security-and-quality-assurance-information-security-and-quality-assurance-projects-issue-tracker.json
// module id = 2166
// module chunks = 231608221292675